// Campaign selectors retain real Core entity IDs; display names are presentation only.
export const getCampaignOptions = (campaigns, availableSites) => {
  const allowed = new Set((availableSites || []).map(site => typeof site === 'string' ? site : site.id));
  return campaigns.filter(campaign => (campaign.sites || []).some(site => allowed.has(
    typeof site === 'string' ? site : site.id
  ))).map(campaign => ({ ...campaign, campaignId: campaign.id,
    name: campaign.displayName, displayName: campaign.displayName }))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
};
